import { useTranslation } from "react-i18next";
import { ScrollableContainer, StyledPageWrapper, Title } from "@monorepo/components";

import GsmVoucherVendorsList from "components/Services/GsmVoucherVendorsList";
import { PageWrapper } from "components/Services/ServicesPage";

const GsmVouchersVendors = () => {
  const { t } = useTranslation();
  return (
    <StyledPageWrapper>
      <PageWrapper>
        <Title>{t("gsmVoucherServices.buy_code")}</Title>
        <ScrollableContainer>
          <GsmVoucherVendorsList />
        </ScrollableContainer>
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default GsmVouchersVendors;
